export const HOST_NAME = 'doxa.team';
export const PRODUCTION_SITE_URL = `https://${HOST_NAME}`;
